export default "__VITE_ASSET__BDuFdQ_Y__"